import { render, staticRenderFns } from "./InvestRow.vue?vue&type=template&id=03f37b1a&scoped=true&"
import script from "./InvestRow.vue?vue&type=script&lang=js&"
export * from "./InvestRow.vue?vue&type=script&lang=js&"
import style0 from "./InvestRow.vue?vue&type=style&index=0&id=03f37b1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f37b1a",
  null
  
)

export default component.exports